<template>
  <b-modal v-model="selectColumnModalVisible" :title="editMode ? 'edit component' : 'add column to view'" @ok="add">
    <template #title>
      {{ editMode ? 'edit component' : 'add column to view' }}
      <modal-help topic="add-form-field" />
    </template>
    <b-container fluid>
      <b-form>
        <b-row>
          <b-form-group label="select column">
            <b-form-select v-model="selectedColumn" :options="spreadSheetColumnOptions" class="mb-3" size="sm" placeholder="selectcolumn" required />
          </b-form-group>
        </b-row>
        <b-row class="field-group">
          <b-form-group label="title">
            <small class="field-hint">shown above the field</small>
            <b-form-input v-model="title" size="sm" />
          </b-form-group>
        </b-row>
        <b-row class="field-group">
          <b-form-group label="description">
            <small class="field-hint">displayed below the form element</small>
            <b-form-input v-model="description" size="sm" />
          </b-form-group>
        </b-row>
        <b-row class="field-group">
          <b-form-group label="placeholder text">
            <small class="field-hint">displayed inside the form element</small>
            <small v-if="!(title || '').trim() && (placeholder || '').trim()" class="field-hint">Visitors hear the placeholder as the field name.</small>
            <b-form-input v-model="placeholder" size="sm" />
          </b-form-group>
        </b-row>
        <b-row v-if="isMultiselect" class="field-group">
          <b-form-group label="input control">
            <small class="field-hint">how this field's choices are shown. the choices and single or multiple selection are set on the spreadsheet field.</small>
            <b-form-select v-model="displayStyle" :options="displayStyleOptions" size="sm" />
          </b-form-group>
        </b-row>
      </b-form>
    </b-container>
  </b-modal>
</template>

<script>

  export default {

    data() {

      return {
        selectColumnModalVisible: false,
        selectedColumn: {},
        spreadSheetColumnOptions: [],
        title: ``,
        autoPopulatedTitle: ``,
        description: ``,
        placeholder: ``,
        displayStyle: `dropdown`,
        displayStyleOptions: [
          { value: `checkboxes`, text: `checkboxes` },
          { value: `radio`, text: `radio buttons` },
          { value: `dropdown`, text: `dropdown list` },
          { value: `list`, text: `multiple select list` }
        ],
        editMode: false,
        parentEditor: null
      }
    },
    computed: {
      selectedColumnOption () {

        return _.find(this.spreadSheetColumnOptions, (option) => {

          return option.value === this.selectedColumn
        })
      },
      isMultiselect () {

        return this.selectedColumnOption && this.selectedColumnOption.type === `multiselect`
      }
    },
    watch: {
      selectedColumn (newVal) {

        const selected = _.find(this.spreadSheetColumnOptions, (option) => {

          return option.value === newVal
        })

        if (selected && (this.title === `` || this.title === this.autoPopulatedTitle)) {

          this.title = selected.text
          this.autoPopulatedTitle = selected.text
        }
      }
    },
    methods: {
      add () {

        if (this.parentEditor.showEditFormComponent) {

          this.parentEditor.showEditFormComponent(this.parentEditor.form.components, this.parentEditor.spreadSheetUniqueTitle)
        } else if (this.parentEditor.showEditTableComponent) {

          this.parentEditor.showEditTableComponent(this.parentEditor.table.components, this.parentEditor.spreadSheetUniqueTitle)
        }

        if (this.editMode) {

          this.parentEditor.editComponentInActiveSlot(this.selectedColumn, this.title, this.description, this.placeholder, this.multiselectConfig())
        } else {

          this.parentEditor.addComponentToActiveSlot(this.selectedColumn, this.title, this.description, this.placeholder, this.multiselectConfig())
        }
      },
      multiselectConfig () {

        if (!this.isMultiselect) {

          return null
        }

        return {
          displayStyle: this.displayStyle || `dropdown`,
          selectionMode: (this.selectedColumnOption && this.selectedColumnOption.selectionMode) || `multiple`
        }
      },
      showSelectColumnModal () {

        this.editMode = false
        this.title = ``
        this.autoPopulatedTitle = ``
        this.description = ``
        this.placeholder = ``
        this.displayStyle = `dropdown`
        this.selectColumnModalVisible = true
      },
      showEditColumnModal (component) {

        this.editMode = true
        this.title = component.title || ``
        this.autoPopulatedTitle = ``
        this.description = component.description || ``
        this.placeholder = component.placeholder || ``
        this.selectedColumn = component.uniqueTitle
        this.displayStyle = component.displayStyle || `dropdown`
        this.selectColumnModalVisible = true
      }
    }
  }
</script>

<style scoped>
.field-hint {
  font-style: italic;
  color: #888;
  display: block;
  margin-bottom: 4px;
}
.field-group {
  margin-top: 12px;
}
</style>